import React, { Component, createRef } from "react";
import DragSortableList from "Projects/CC_cubi_clan_project/GlobalComponents/DragSortableList/DragSortableList";
import {
  toDataUrl,
  getStableKey,
  resolveParentIndex,
  stripDataUrl,
  makeClientId,
} from "Projects/CC_cubi_clan_project/GlobalComponents/DragSortableList/dndUtils";
import { mfmMediumUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import "./GallerySection.css";

/**
 * Props:
 *  - fotos: [
 *      { idFoto?, imageBase64, externalId?, sortOrder? }
 *    ]
 *  - onEdit(index, item)      // índice REAL del array del padre
 *  - onChange(updatedArray)   // DragSortableList devuelve array reindexado (sortOrder = i+1)
 */

// Extractores de ID (prioridad): idFoto -> externalId
const fotoId = (f) => f?.idFoto;
const extId = (f) => f?.externalId;
// Fallback para elementos nuevos sin ID: por imageBase64
const fallback = (a, b) =>
  !a?.idFoto && stripDataUrl(a?.imageBase64) === stripDataUrl(b?.imageBase64);

export default class GallerySection extends Component {
  static defaultProps = { fotos: [] };

  constructor(props) {
    super(props);
    this.mfmRef = createRef();
  }

  /** Reordenación (y reindexado) gestionada por DragSortableList */
  handleReorder = (updated) => {
    // Eliminamos cualquier rastro de isCover por si llegase desde props antiguas
    const sanitized = updated.map(({ isCover, ...rest }) => rest);
    this.props.onChange && this.props.onChange(sanitized);
  };

  /** Abrir modal: índice REAL en el padre, resuelto por IDs */
  handleOpen = (item, visibleIndex) => {
    const parentArr = this.props.fotos || [];
    const realIndex = resolveParentIndex(
      parentArr,
      item,
      [fotoId, extId],
      fallback
    );
    const indexForParent = realIndex >= 0 ? realIndex : visibleIndex;
    this.props.onEdit && this.props.onEdit(indexForParent, item);
  };

  /** Añade imagen recibida del uploader MFM al final de la galería */
  handleMfmUpload = (result) => {
    if (!result?.uuid) return;
    const newItem = { __cid: makeClientId(), idFoto: null, imageUuid: result.uuid, imageBase64: null, externalId: "" };
    const merged = [...(this.props.fotos || []), newItem];
    this.props.onChange && this.props.onChange(merged);
  };

  /* Tarjeta/thumbnail de imagen */
  renderItem = (item, idx, { over }) => {
    const src = item?.imageUuid ? mfmMediumUrl(item.imageUuid) : toDataUrl(item?.imageBase64);
    return (
      <div
        className={`gallery-thumb ${over ? "is-over" : ""}`}
        onClick={() => this.handleOpen(item, idx)}
        title={`Orden ${item?.sortOrder ?? idx + 1}`}
      >
        <img
          className="gallery-img"
          src={src}
          alt={`foto ${idx + 1}`}
          draggable={false}
        />
      </div>
    );
  };

  render() {
    const { fotos } = this.props;

    return (
      <section className="gallery-section section-block">
        {/* Toolbar solo con título */}
        <div className="gallery-toolbar">
          <h3 className="project-subtitle m-0">Galería de fotos</h3>
          <div className="spacer" />
        </div>

        {/* DnD controlado */}
        <DragSortableList
          items={fotos}
          orderProp="sortOrder"
          getKey={(item, idx) => getStableKey(item, idx, [fotoId, extId, (i) => i?.__cid])}
          renderItem={this.renderItem}
          onChange={this.handleReorder}
        />

        {/* Botón añadir */}
        <div
          className="section-add-tile"
          onClick={() => this.mfmRef.current?.openModal()}
        >
          <span className="section-add-plus">＋</span>
          <span>Añadir imagen</span>
        </div>
        {/* MfmImageUploader headless: toda la lógica de subida y biblioteca */}
        <MfmImageUploader
          ref={this.mfmRef}
          headless
          appCode="MUGIN"
          library="fotos"
          mediaType="image"
          onUpload={this.handleMfmUpload}
        />
      </section>
    );
  }
}
